<template>
  <div>
    <div ref="TopLeft" class="scroller posabs">
      <!-- <button @click="locateMyself()">Lodate Myself</button> -->
      <!--
      u-layer colored-layer
      <pre>{{ myself }}</pre>
      <pre>{{ players }}</pre>
      <pre>{{ room }}</pre>
      <pre>{{ root }}</pre> -->
    </div>

    <div ref="LeaderBoard" class="overlay leaderboard">
      <LeaderBoard @find-player="locatePlayer({ player: $event.player })" @find-myself="locateMyself()" v-if="activeTiles && players" :players="players" :activeTiles="activeTiles" @overlay="(v) => { overlay = v }"></LeaderBoard>
    </div>

    <div ref="GeneratingCells" v-show="overlay === 'gen-cells'" class="u-layer scroller posabs colored-layer full centerise">
      <div class="gen-cells-title">
        Generating Cells
      </div>
    </div>

    <div ref="GameOver" class="overlay gameover" v-show="gameover">
      <div class="gv-box" v-if="gameover">
        <div class="gv-title">You are killed by: {{ gameover.killer.displayName }}</div>
        <button class="gv-restart" @click="gameover.cb()">Restart.</button>
      </div>
    </div>

  </div>
</template>

<script>
import * as Game from '../api/fire.game.js'
import _ from 'lodash'
import { async } from 'q';
var TWEEN = require('@tweenjs/tween.js')

// import { Promise } from 'q';
// import { setTimeout } from 'timers';
let THREE = {
  ...require('three')
}
var raycaster = new THREE.Raycaster()
var mouse = new THREE.Vector2()
/* eslint-disable */
function onMouseMove(event) {
	// calculate mouse position in normalized device coordinates
	// (-1 to +1) for both components
	mouse.x = (event.clientX / window.innerWidth) * 2 - 1
	mouse.y = - (event.clientY / window.innerHeight) * 2 + 1
}
window.addEventListener('mousemove', onMouseMove, false)

function onTouchMove(event) {
	// calculate mouse position in normalized device coordinates
	// (-1 to +1) for both components
	mouse.x = (event.touches[0].clientX / window.innerWidth) * 2 - 1
	mouse.y = - (event.touches[0].clientY / window.innerHeight) * 2 + 1
}
window.addEventListener('touchmove', onTouchMove, false)


function onTouchStart(event) {
	// calculate mouse position in normalized device coordinates
	// (-1 to +1) for both components
	mouse.x = (event.touches[0].clientX / window.innerWidth) * 2 - 1
	mouse.y = - (event.touches[0].clientY / window.innerHeight) * 2 + 1
}
window.addEventListener('touchstart', onTouchStart, false)

let resolution = new THREE.Vector2(window.innerWidth, window.innerHeight)
window.addEventListener('resize', () => {
  resolution.x = window.innerWidth
  resolution.y = window.innerHeight
})

window.addEventListener('orientationchange', () => {
  resolution.x = window.innerWidth
  resolution.y = window.innerHeight
})

const FSCalc = ({ zPos, camera }) => {
  var cameraZ = camera.position.z
  var distance = cameraZ - zPos
  var aspect = window.innerWidth / window.innerHeight
  var vFov = camera.fov * Math.PI / 180
  var planeHeightAtDistance = 2 * Math.tan(vFov / 2) * distance
  var planeWidthAtDistance = planeHeightAtDistance * aspect

  /*
  let dist = camera.position.z - mesh.position.z
  let height = ... // desired height to fit
  camera.fov = 2 * Math.atan(height / (2 * dist)) * (180 / Math.PI)
  camera.updateProjectionMatrix()
  */

  return {
    aspect: planeWidthAtDistance / planeHeightAtDistance,
    vmin: Math.min(planeWidthAtDistance, planeHeightAtDistance),
    vmax: Math.max(planeWidthAtDistance, planeHeightAtDistance),
    width: planeWidthAtDistance,
    height: planeHeightAtDistance
  }
}

window.requestIdleCallback =
  window.requestIdleCallback ||
  function (cb) {
    var start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        }
      });
    }, 1);
  }

window.cancelIdleCallback =
  window.cancelIdleCallback ||
  function (id) {
    clearTimeout(id);
  }
/* eslint-enable */

export default {
  props: {
    UI: {},
    gameID: {}
  },
  components: {
    LeaderBoard: () => import('../ui/LeaderBoard.vue'),
  },
  beforeDestroy () {
    let BASE = this.UI.$refs['base']
    if (BASE) {
      BASE.removeChild(this.$refs['GeneratingCells'])
      BASE.removeChild(this.$refs['LeaderBoard'])
      BASE.removeChild(this.$refs['TopLeft'])
      BASE.removeChild(this.$refs['GameOver'])
    }
    this.hasLeft = true
    this.$parent.$emit('remove', this.pointcloud)
  },
  mounted () {
    let BASE = this.UI.$refs['base']
    if (BASE) {
      BASE.appendChild(this.$refs['GeneratingCells'])
      BASE.appendChild(this.$refs['LeaderBoard'])
      BASE.appendChild(this.$refs['TopLeft'])
      BASE.appendChild(this.$refs['GameOver'])
    }
    this.initSystemEngines()
  },
  data () {
    return {
      gameover: false,
      t1: false,
      t2: false,
      deadAround: [],
      deadCells: [],
      highlightTiles: [],
      activeTiles: false,
      highlightClickers: [],

      stridesMap: new Map(),
      overlay: false,
      root: false,
      players: false,
      myself: false,
      room: {}
    }
  },
  methods: {
    stopSpinner () {
      this.UI.runGeoVert = false
    },
    startSpinner () {
      this.UI.runGeoVert = true
    },
    getGameData () {
      return Game.getGameData({ gameID: this.gameID })
    },
    generateCells () {
      return new Promise((resolve) => {
        let root = Game.makeRoot()
        Game.makeBrick(root, this.room.sizeX, this.room.sizeY)
        setTimeout(() => {
          resolve(root)
        }, 0)
      })
    },
    getPlayers () {
      return new Promise((resolve) => {
        Game.listAllPlayers({
          gameID: this.room.roomID,
          onArrive: ({ result }) => {
            this.players = result
            resolve(result)
          }
        })
      })
    },
    getPlayerSelfGameID () {
      return Game.getPlayerSelfGameID({ gameID: this.gameID })
    },
    // initMyPlayerSelf () {
    //   return Game.initMyPlayerSelf({ root: this.root, gameID: this.gameID })
    // },
    getMyPlayerSelf () {
      return Game.getMyPlayerSelf({ gameID: this.gameID })
    },
    joinGame () {
      return Game.joinGame({ gameID: this.gameID, root: this.root })
    },
    async initSystemEngines () {
      this.overlay = 'gen-cells'
      this.UI.useBloomMode('loading')
      this.startSpinner()

      // load the essential data
      this.room = await this.getGameData()
      this.root = await this.generateCells()
      this.players = await this.getPlayers()
      await this.joinGame()

      // let hasJoinedRoom = await this.getPlayerSelfGameID()
      // console.log(hasJoinedRoom)
      // if (!hasJoinedRoom) {
      //   // await this.initMyPlayerSelf()
      //   this.myself = await this.getMyPlayerSelf()

      // } else {
      //   this.myself = await this.getMyPlayerSelf()
      // }

      this.myself = await this.getMyPlayerSelf()

      this.onCultureReady()
      if (process.env.NODE_ENV === 'production') {
        await this.sleep(3000)
      } else {
        await this.sleep(0)
      }
      this.overlay = false
      this.stopSpinner()
      this.UI.useBloomMode('board')
      this.makeBoardGL()
      this.locateMyself()
    },
    sleep (ms) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, ms)
      })
    },
    refresher (tiles) {
      this.activeTiles = tiles.filter(t => !t.dead)
      let deadTiles = tiles.filter(t => t.dead)
      this.deadCells = deadTiles
      this.cleaner = this.root.bricks.slice()
      this.deadAround = this.getCornerTiles(deadTiles)

      this.highlightTiles = this.goHighlightTiles(this.activeTiles)
      this.highlightClickers = this.highlightTiles.slice()
      this.$forceUpdate()

      // console.log(this.highlightTiles)

      // this.goCheckCellCoreDead()
      this.goCheckcutOff()
    },
    goCheckcutOff () {
      let map = this.root.xymap
      let activeMap = {}
      let getActive = (item) => {
        if (!item) {
          return false
        }
        return activeMap[item.xid + '-' + item.yid]
      }

      // sync to map
      this.activeTiles.forEach((active) => {
        active.hasEnergy = false
        activeMap[active.xid + '-' + active.yid] = active
      })

      let getAround = (cell, userID) => !cell ? [] : [
        activeMap[(cell.xid + 0) + '-' + (cell.yid + 1)],
        activeMap[(cell.xid + 0) + '-' + (cell.yid - 1)],
        activeMap[(cell.xid + 1) + '-' + (cell.yid + 0)],
        activeMap[(cell.xid - 1) + '-' + (cell.yid + 0)],

        // activeMap[(cell.xid + 1) + '-' + (cell.yid + 1)],
        // activeMap[(cell.xid - 1) + '-' + (cell.yid - 1)],
        // activeMap[(cell.xid + 1) + '-' + (cell.yid - 1)],
        // activeMap[(cell.xid - 1) + '-' + (cell.yid + 1)]
      ].filter(e => !!e && e.belongsTo === userID)

      let energise = (items) => {
        items.forEach((item) => {
          let target = getActive(item)
          if (target) {
            target.hasEnergy = true
          }
        })
      }

      const timeoutPromise = (timeout) => new Promise((resolve) => setTimeout(resolve, timeout));
      const immediatePromise = (timeout) => new Promise((resolve) => window.setImmediate(resolve));

      let canGoNextStep = async (items, userID, player) => {
        let expanded = []
        // only add when the item dont have
        let weakset = new WeakSet()

        // items = items.filter((t) => {
        //   return t.belongsTo === userID
        // })

        let start = window.performance.now()
        for (var kn in items) {
          let proc = window.performance.now() - start
          // time slice performance optimistaion
          // let the browser to do some rendering
          if (proc > 50) {
            start = window.performance.now()
            await immediatePromise(0)
          }

          let ii = items[kn]
          getAround(ii, userID).forEach((item) => {
            if (!weakset.has(item)) {
              expanded.push(item)
              weakset.add(item)
            }
          })
          // expanded = [...expanded, ...getAround(ii)]
        }

        // items.forEach(async (ii) => {
        // })

        expanded = expanded.filter((t) => {
          return t.belongsTo === userID
        })

        expanded = expanded.filter((t) => {
          return !getActive(t).hasEnergy
        })

        return {
          expanded,
          canGoFurther: expanded.length > 0
        }
      }

      let totalDeadcells = []
      let resolve = (userID, player) => {
        // let deadCells = []
        let energised = this.activeTiles.filter(a => a.belongsTo === userID).filter((t) => {
          return getActive(t) && getActive(t).hasEnergy
        })
        let left = this.activeTiles.filter(a => a.belongsTo === userID).filter((t) => {
          return getActive(t) && !getActive(t).hasEnergy
        })

        // deadCells.push(...left)
        totalDeadcells.push(...left)

        player.doneClean = true

        console.log('user', userID, 'energised cell', energised.length, 'dead cell', left.length)
        if (this.players.filter(p => p.doneClean).length === this.players.length) {
          // this.$emit('my-cells-are-dead', totalDeadcells)
          this.onCleanDeadCells({ deadCells: totalDeadcells })
        }
      }

      window.requestIdleCallback =
        window.requestIdleCallback ||
        function (cb) {
          var start = Date.now();
          return setTimeout(function () {
            cb({
              didTimeout: false,
              timeRemaining: function () {
                return Math.max(0, 50 - (Date.now() - start));
              }
            });
          }, 1);
        }

      window.cancelIdleCallback =
        window.cancelIdleCallback ||
        function (id) {
          clearTimeout(id);
        }

      let popagate = async (hand, userID, player) => {
        let { expanded, canGoFurther } = await canGoNextStep(hand, userID, player)
        if (canGoFurther) {
          hand = expanded
          energise(hand)
          await timeoutPromise(1)
          popagate(hand, userID, player)
        } else {
          resolve(userID, player)
        }
      }

      let users = _.groupBy(this.activeTiles, 'belongsTo')
      console.log(users)
      this.players.forEach(p => {
        p.doneClean = false
      })
      this.players.forEach((player) => {
        setTimeout(() => {
          let cellCore = player.gameInfo.cellCore
          let userID = player.userID
          let myCore = getActive(cellCore)

          energise([myCore], userID, player)
          popagate([myCore], userID, player)
        }, 10)
      })
    },
    goHighlightTiles (activeTiles) {
      let map = this.root.xymap
      let info = activeTiles.filter(a => a.belongsTo === this.myself.userID).reduce((info, tile) => {
        let found = [
          map[(tile.xid + 0) + '-' + (tile.yid + 1)],
          map[(tile.xid + 0) + '-' + (tile.yid - 1)],
          map[(tile.xid + 1) + '-' + (tile.yid + 0)],
          map[(tile.xid - 1) + '-' + (tile.yid + 0)],

          // map[(tile.xid + 1) + '-' + (tile.yid + 1)],
          // map[(tile.xid - 1) + '-' + (tile.yid - 1)],
          // map[(tile.xid + 1) + '-' + (tile.yid - 1)],
          // map[(tile.xid - 1) + '-' + (tile.yid + 1)],
        ].filter(e => e)
        info.bucket.push(...found)
        return info
      }, {
        xymap: this.root.xymap,
        bucket: []
      })
      info.bucket = _.uniqBy(info.bucket.slice(), 'numID')
      info.bucket = info.bucket.filter((t) => {
        return !this.activeTiles.some(a => a.numID === t.numID && a.belongsTo === this.myself.userID)
      })
      return info.bucket
    },
    onCultureReady () {
      return Game.onTilesArrive({
        gameID: this.myself.gameID,
        myself: this.myself,
        onArrive: (tiles) => {
          this.refresher(tiles)
        },
        onCellCoreDestroy: (userID) => {
          if (userID) {
            let killer = this.players.find(p => p.userID === userID)
            if (killer) {
              console.log('you are killed by userID..........', userID)
              this.gameover = {
                killer: killer,
                cb: () => {
                  // Game.joinGame({ root: this.root, gameID: this.room.roomID })
                  //   .then((myself) => {
                  //     this.$emit('gameover', false)
                  //     this.$emit('myself', myself)
                  //     this.$parent.findPlayer({ player: myself })
                  //     this.$nextTick(() => {
                  //       this.highlightTiles = []
                  //       this.refresher(this.activeTiles)
                  //     })
                  //   })

                  window.location.assign(`/_/${encodeURIComponent(this.myself.gameID)}`)
                }
              }
              // this.$emit('gameover', )
              // Game.cleanUp({ gameID: this.myself.gameID, player: this.myself })
              //   .then(() => {
              //   })
            }
            this.$forceUpdate()
          }
        }
      })
    },
    onCleanDeadCells ({ deadCells = [] }) {
      Game.removeDeadCells({ deadCells, gameID: this.gameID })
    },
    getCornerTiles (deadTiles) {
      let map = this.root.xymap
      let info = deadTiles.filter(a => a.belongsTo === this.myself.userID).reduce((info, tile) => {
        let found = [
          map[(tile.xid + 0) + '-' + (tile.yid + 1)],
          map[(tile.xid + 0) + '-' + (tile.yid - 1)],
          map[(tile.xid + 1) + '-' + (tile.yid + 0)],
          map[(tile.xid - 1) + '-' + (tile.yid + 0)],

          // map[(tile.xid + 1) + '-' + (tile.yid + 1)],
          // map[(tile.xid - 1) + '-' + (tile.yid - 1)],
          // map[(tile.xid + 1) + '-' + (tile.yid - 1)],
          // map[(tile.xid - 1) + '-' + (tile.yid + 1)]
        ].filter(e => e)
        info.bucket.push(...found)
        return info
      }, {
        xymap: this.root.xymap,
        bucket: []
      })
      info.bucket = _.uniqBy(info.bucket.slice(), 'numID')
      info.bucket = info.bucket.filter((t) => {
        return !this.activeTiles.some(a => a.numID === t.numID && a.belongsTo === this.myself.userID)
      })
      return info.bucket
    },

    // goCheckCellCoreDead () {
    //   // console.log(this.myself)
    //   let activeCellCore = this.activeTiles.find(a => a.numID === this.myself.gameInfo.cellCore.numID)
    //   if (activeCellCore) {
    //     // cell core captured
    //     if (activeCellCore.belongsTo !== this.myself.userID) {
    //       // FDB.ref(`/players/${gameID}/players/${this.myself.userID}`).remove()
    //     }
    //   }
    // },

    locatePlayer ({ player, zLevel = 2000 }) {
      // console.log(player)
      let numID = player.gameInfo.cellCore.numID
      let stride = this.stridesMap.get(numID)

      let x = this.geometry.attributes.position.array[stride * 3 + 0]
      let y = this.geometry.attributes.position.array[stride * 3 + 1]
      // let z = this.geometry.attributes.position.array[stride * 3 + 2]

      let coord = { ...this.UI.camera.position }

      setTimeout(() => {
        // if (this.t1) {
        //   this.t1.stop()
        // }
        // if (this.t2) {
        //   this.t2.stop()
        // }

        let t1 = new TWEEN.Tween(coord)
          .to({ x, y, z: zLevel }, 1500)
          .easing(TWEEN.Easing.Quadratic.Out)
          .onUpdate(() => {
            this.UI.control.target0.x = coord.x
            this.UI.control.target0.y = coord.y
            this.UI.control.target0.z = 0
            this.UI.control.position0.x = coord.x
            this.UI.control.position0.y = coord.y
            this.UI.control.position0.z = coord.z
            this.UI.control.reset()
          })
        let t2 = new TWEEN.Tween(coord)
          .to({ x, y, z: window.innerWidth > 500 ? 200 : 80 }, 1000)
          .easing(TWEEN.Easing.Quadratic.Out)
          .onUpdate(() => {
            this.UI.control.target0.x = coord.x
            this.UI.control.target0.y = coord.y
            this.UI.control.target0.z = 0
            this.UI.control.position0.x = coord.x
            this.UI.control.position0.y = coord.y
            this.UI.control.position0.z = coord.z
            this.UI.control.reset()
          })

        t1.chain(t2)
        t1.start()

        console.log(x,y)
        console.log(coord.x,coord.y)

      }, 1)
      // console.log(x, y, z)
    },
    locateMyself () {
      this.locatePlayer({ player: this.myself, zLevel: 2000 })
    },
    onClickBrick ({ numID, xid, yid, tile }) {
      if (process.env.NODE_ENV === 'development') {
        if (window.goCapture === true) {
          if (this.highlightClickers.some(e => e.numID === numID)) {
            Game.setTileToMineProperly({ gameID: this.gameID, numID, tile, players: this.players, activeTiles: this.activeTiles })
            return
          }
        } else if (window.goDelete === true) {
          Game.adminResetCell({ gameID: this.gameID, cell: tile })
          return
        }
        // esle if ....
      }

      let isHighLighted = this.highlightClickers.some(e => e.numID === numID)

      let clickedActiveCell = this.activeTiles.find(a => a.numID === numID)
      let isMyCell = clickedActiveCell && clickedActiveCell.belongsTo === this.myself.userID
      let canDownGrade = clickedActiveCell && clickedActiveCell.upgradeLevel > 0

      let isCellCore = clickedActiveCell && this.players.some(p => p.gameInfo.cellCore.numID === clickedActiveCell.numID)

      console.log(tile)

      // let notMyCellCore = this.myself.gameInfo.cellCore.numID !== tile.numID

      // let isOthersCell = tile.belongsTo !== this.myself.userID
      // let upgradeNumber = thisActiveCell.upgradeNumber ? thisActiveCell.upgradeNumber : 0

      let canAttack = isHighLighted
      if (canAttack) {
        if (canDownGrade) {
          Game.downgradeCell({ cell: tile, gameID: this.gameID })
        } else {
          Game.setTileToMineProperly({ gameID: this.gameID, numID, tile, players: this.players, activeTiles: this.activeTiles })
        }
      } else {
        if (isMyCell) {
          Game.upgradeCell({ gameID: this.gameID, cell: tile })
        }
      }


      // if (isMyCell && notMyCellCore) {
      //   Game.upgradeCell({ gameID: this.gameID, cell: tile })
      // } else if (isHighLighted) {
      //   if (upgradeNumber > 0) {
      //     Game.downgradeCell({ cell: tile, gameID: this.gameID })
      //   } else {
      //     Game.setTileToMineProperly({ gameID: this.gameID, numID, tile, players: this.players, activeTiles: this.activeTiles })
      //   }
      // }



      // if (this.activeTiles.filter(e => e.numID !== this.myself.gameInfo.cellCore.numID).some(e => e.belongsTo === this.myself.userID)) {
      //   // console.log(numID)
      //   Game.upgradeCell({ gameID: this.gameID, cell: tile })
      // } else if (this.highlightClickers.some(e => e.numID === numID)) {
      //   let food = this.activeTiles.find(e => e.numID === numID)
      //   console.log(food)

      //   if (Number(food.upgradeLevel) > 0) {
      //     Game.downgradeCell({ gameID: this.gameID, cell: tile })
      //   } else {
      //     Game.setTileToMineProperly({ gameID: this.gameID, numID, tile, players: this.players, activeTiles: this.activeTiles })
      //     // Game.downgradeCell({  gameID: this.gameID, cell: tile })
      //   }
      //   // click highlighted tiles
      // }
    },
    makeBoardGL () {
      var PARTICLE_SIZE = 25.0

      var counter = this.root.xnum * this.root.ynum
      var cellStatus = new Float32Array(counter * 1)
      var cellUpgradeLevel = new Float32Array(counter * 1)

      var positions = new Float32Array(counter * 3)
      var cellColorsArray = new Float32Array(counter * 3)
      var borderColorsArray = new Float32Array(counter * 3)
      // var stridesMap = {}
      // var stridesMaper = this.stridesMap
      var color = new THREE.Color()

      var xmax = this.root.xnum
      var ymax = this.root.ynum
      var stride3 = 0
      // var stride2 = 0
      var stride1 = 0
      for (var column = 0; column < ymax; column++) {
        for (var row = 0; row < xmax; row++) {
          var root = this.root
          var sizePlusPad = PARTICLE_SIZE
          var br = root.bricks[stride1]
          var { x, y, z } = {
            x: br.xid * sizePlusPad - (root.xnum) * sizePlusPad * 0.5,
            y: br.yid * sizePlusPad - (root.ynum) * sizePlusPad * 0.5,
            z: 0
          }

          this.stridesMap.set(br.numID, stride1)

          cellStatus[stride1 + 0.0] = 0

          cellUpgradeLevel[stride1 + 0] = br.upgradeLevel || 0

          positions[stride3 + 0.0] = x * 1.05
          positions[stride3 + 1.0] = y * -1.05
          positions[stride3 + 2.0] = z

          // color.setHSL((stride1 / counter), 1.0, 0.7)
          // color.setHSL(0.5, 0.5, 0.7)
          color.setHex(0x100B36)

          cellColorsArray[stride3 + 0.0] = color.r
          cellColorsArray[stride3 + 1.0] = color.g
          cellColorsArray[stride3 + 2.0] = color.b

          // color.setHSL(((counter - stride1) / counter), 1.0, 0.5)

          color.setHex(0x0A0721)

          borderColorsArray[stride3 + 0.0] = color.r
          borderColorsArray[stride3 + 1.0] = color.g
          borderColorsArray[stride3 + 2.0] = color.b

          stride1 += 1
          stride3 += 3
        }
      }

      var geometry = new THREE.BufferGeometry()
      geometry.addAttribute('cellUpgradeLevel', new THREE.BufferAttribute(cellUpgradeLevel, 1).setDynamic(true))
      geometry.addAttribute('cellStatus', new THREE.BufferAttribute(cellStatus, 1).setDynamic(true))
      geometry.addAttribute('position', new THREE.BufferAttribute(positions, 3))
      geometry.addAttribute('cellColor', new THREE.BufferAttribute(cellColorsArray, 3).setDynamic(true))
      geometry.addAttribute('borderColor', new THREE.BufferAttribute(borderColorsArray, 3).setDynamic(true))
      this.geometry = geometry

      let uniforms = {
        time: {
          value: 0
        },
        screen: {
          value: new THREE.Vector2(10, 10)
        },
        resolution: {
          value: resolution
        }
      }
      const material = new THREE.ShaderMaterial({
        alphaTest: 0.9,
        defines: {
          [`CAM_Z_POS`]: `${(this.UI.camera.position.z * 10).toFixed(1)}`,
          [`PARTICLE_SIZE`]: `${PARTICLE_SIZE.toFixed(1)}`
        },
        uniforms,
        // side: THREE.DoubleSide,
        transparent: true,
        vertexShader: `
          #include <common>
          varying vec3 vCellColor;
          varying vec3 vBorderColor;
          varying float vCellStatus;
          varying float vCellUpgradeLevel;

          attribute vec3 cellColor;
          attribute vec3 borderColor;

          uniform vec2 resolution;
          uniform vec2 screen;
          uniform float time;

          attribute float cellStatus;
          attribute float cellUpgradeLevel;

          void main(){
            vec3 nPos = position;

            // nPos.x += nPos.x * sin(2.0 * time + nPos.y / resolution.y) * 0.001;
            // nPos.y += nPos.y * sin(2.0 * time + nPos.x / resolution.x) * 0.001;

            vec4 mvPosition = modelViewMatrix * vec4(nPos, 1.0);
            vec4 clipper = projectionMatrix * mvPosition;


            // tpye -1 cell cores
            // type 0 = black

            // type 5 = fortified tiles
            // type 1 = active tiles
            // type 2 = hihglgiht

            // cellStatus 2.0 = can click on it
            if (cellStatus == 2.0) {
              vCellColor = cellColor * abs(0.95 + 0.15 * sin(time * 5.0));
            } else if (cellStatus == 5.0) {
              vCellColor = cellColor - 0.35;
            } else if (cellStatus == 0.0) {
              vCellColor = cellColor;
            } else if (cellStatus == 1.0) {
              vCellColor = cellColor - 0.35;
            } else {
              vCellColor = cellColor;
            }

            vCellStatus = cellStatus;
            vBorderColor = borderColor;

            float aspect = resolution.y / resolution.x;
            float sy = resolution.y / screen.y;
            float sa = CAM_Z_POS / -mvPosition.z;
            float dpi = 2.0;
            float pointSize = PARTICLE_SIZE;

            if (aspect > 1.0) {
              gl_PointSize = pointSize * dpi / 10.0 * sy * sa;
            } else {
              gl_PointSize = pointSize * dpi / 10.0 * sy * sa;
            }

            // if (aspect > 1.0) {
            //   gl_PointSize = pointSize * dpi / 10.0 * sy * sa;
            // } else {
            //   gl_PointSize = pointSize * dpi / 10.0 * sy * sa;
            // }

            gl_Position = clipper;
          }
        `,
        fragmentShader: `
          #include <common>

          varying vec3 vCellColor;
          varying vec3 vBorderColor;
          varying float vCellStatus;

          uniform float time;
          uniform vec2 resolution;

          mat3 rotateZ(float rad) {
              float c = cos(rad);
              float s = sin(rad);
              return mat3(
                  c, s, 0.0,
                  -s, c, 0.0,
                  0.0, 0.0, 1.0
              );
          }
          mat3 rotateX(float rad) {
              float c = cos(rad);
              float s = sin(rad);
              return mat3(
                  1.0, 0.0, 0.0,
                  0.0, c, s,
                  0.0, -s, c
              );
          }

          // tpye -1 cell cores
          // type 0 = black

          // type 5 = fortified tiles
          // type 1 = active tiles
          // type 2 = hihglgiht

          void main (void) {
            float dist = length(gl_PointCoord.xy - 0.5);
            if (dist > 0.5) {
              discard;
            } else {
              if (vCellStatus <= -2.0) {
                if (dist < 0.4) {
                  gl_FragColor = vec4(vCellColor.rgb, 1.0);
                } else if (dist < 0.45) {
                  gl_FragColor = vec4(vBorderColor.rgb * gl_PointCoord.xyx * rotateZ(time * 5.5), 1.0);
                } else {
                  gl_FragColor = vec4(vBorderColor.rgb, 1.0);
                }
              } else if (vCellStatus <= -1.0) {
                if (dist < 0.45) {
                  gl_FragColor = vec4(vCellColor.rgb + 0.6, 1.0);
                } else {
                  gl_FragColor = vec4(vBorderColor.rgb, 1.0);
                }
              } else if (vCellStatus <= 0.0) {
                if (dist < 0.45) {
                  gl_FragColor = vec4(vCellColor.rgb, 1.0);
                } else {
                  gl_FragColor = vec4(vBorderColor.rgb, 1.0);
                }
              } else if (vCellStatus <= 1.0) {
                if (dist < 0.45) {
                  gl_FragColor = vec4(vCellColor.rgb, 1.0);
                } else {
                  gl_FragColor = vec4(vBorderColor.rgb, 1.0);
                }
              } else if (vCellStatus <= 2.0) {
                if (dist < 0.45) {
                  gl_FragColor = vec4(vCellColor.rgb, 0.6);
                } else {
                  gl_FragColor = vec4(vBorderColor.rgb, 0.6);
                }
              } else if (vCellStatus <= 5.0) {
                if (dist < 0.4) {
                  gl_FragColor = vec4(vCellColor.rgb, 1.0);
                } else if (dist < 0.45) {
                  gl_FragColor = vec4(vBorderColor.rgb * gl_PointCoord.xyx * rotateZ(time * 5.5), 1.0);
                } else {
                  gl_FragColor = vec4(vBorderColor.rgb, 1.0);
                }
              } else {
                //  test to see if this is a varying value bug..

                // if (dist < 0.4) {
                //   gl_FragColor = vec4(vCellColor.rgb, 1.0);
                // } else if (dist < 0.45) {
                //   gl_FragColor = vec4(vBorderColor.rgb * gl_PointCoord.xyx * rotateZ(time * 5.5), 1.0);
                // } else {
                //   gl_FragColor = vec4(vBorderColor.rgb, 1.0);
                // }

                // if (dist < 0.45) {
                //   gl_FragColor = vec4(vCellColor.rgb, 1.0);
                // } else {
                //   gl_FragColor = vec4(vBorderColor.rgb, 1.0);
                // }
              }

            }
          }
        `
      })

      // let tempBorderColor = new THREE.Color('#0A0721')1e1758
      let tempBorderColor = new THREE.Color('#1e1758')

      // cellStatus 2.0 = can click on it
      let setCellType = (numID, type) => {
        let attributes = geometry.attributes
        let stride = this.stridesMap.get(numID)

        attributes.cellStatus.array[stride] = type
        attributes.cellStatus.needsUpdate = true
      }

      let setCellLevel = (numID, type) => {
        let attributes = geometry.attributes
        let stride = this.stridesMap.get(numID)

        attributes.cellUpgradeLevel.array[stride] = type
        attributes.cellUpgradeLevel.needsUpdate = true
      }

      let setBorderColorByNumID = (numID, myColor) => {
        // console.log(myColor)
        let attributes = geometry.attributes
        let stride = this.stridesMap.get(numID)

        tempBorderColor.set(myColor)
        let { r, g, b } = tempBorderColor
        attributes.borderColor.array[stride * 3.0 + 0.0] = r
        attributes.borderColor.array[stride * 3.0 + 1.0] = g
        attributes.borderColor.array[stride * 3.0 + 2.0] = b
        attributes.borderColor.needsUpdate = true
      }

      let tempBallColor = new THREE.Color('#0D092B')
      let setBallColorByNumID = (numID, myColor) => {
        // console.log(myColor)
        let attributes = geometry.attributes
        let stride = this.stridesMap.get(numID)

        tempBallColor.set(myColor)
        let { r, g, b } = tempBallColor
        attributes.cellColor.array[stride * 3.0 + 0.0] = r
        attributes.cellColor.array[stride * 3.0 + 1.0] = g
        attributes.cellColor.array[stride * 3.0 + 2.0] = b
        attributes.cellColor.needsUpdate = true
      }

      let onClick = () => {
        // let particles = this.pointcloud
        // let geometry = particles.geometry
        // let attributes = geometry.attributes

        let intersects = this.intersects || []
        if (intersects.length > 0) {
          // console.log(intersects[0])
          let idx = intersects[0].index
          let brick = this.root.bricks[idx]

          // console.log(({ numID: brick.numID, 'xid': brick.xid, 'yid': brick.yid, brick }))

          this.onClickBrick({
            numID: brick.numID,
            xid: brick.xid,
            yid: brick.yid,
            tile: brick
          })
        }
      }

      let lazyExec = async (arr, fn) => {
        let n = arr.length
        for (var ii = 0; ii < n / 3; ii++) {
          if (arr.length > 0) {
            let item = arr.pop()
            fn(item)
          }
        }
      }

      let forEachOf = (arr, fn) => {
        requestIdleCallback(() => {
          arr.forEach(fn)
        }, { timeout: 2000 })
      }

      let whiter = (tile) => {
        setBallColorByNumID(tile.numID, 0x100B36)
        setBorderColorByNumID(tile.numID, 0x0A0721)
        setCellType(tile.numID, 0)
      }
      let tempColor = new THREE.Color()
      let userDataToStyles = () => {
        lazyExec(this.deadAround, whiter)
        lazyExec(this.deadCells, whiter)

        // lazyExec(this.cleaner, whiter)

        // tpye -1 cell cores
        // type 0 = black

        // type 5 = fortified tiles
        // type 1 = active tiles

        // type 2 = hihglgiht, attackable areas

        // highlighted, can choose to grow
        let myColor = this.myself.myColor
        forEachOf(this.highlightTiles, ((tile) => {
          // tempColor.set(myColor)
          // tempColor.offsetHSL(0, -0.2, -0.41)
          tempColor.set(myColor)
          tempColor.offsetHSL(0, -0.2, -0.3)
          setBallColorByNumID(tile.numID, '#' + tempColor.getHexString())
          setBorderColorByNumID(tile.numID, '#' + tempColor.getHexString())
          setCellType(tile.numID, 2)
        }))

        // active tiles, can be my cells, fortified cells, or dead cells
        forEachOf(this.activeTiles, ((tile) => {

          setBallColorByNumID(tile.numID, tile.color)
          tempColor.set(tile.color)
          tempColor.offsetHSL(0, 0.5, 0.3)
          setBorderColorByNumID(tile.numID, '#' + tempColor.getHexString())
          setCellType(tile.numID, 1)


          let playerCore = this.players.find(p => p.gameInfo.cellCore.numID === tile.numID)
          let isCellCore = this.players.map(p => p.gameInfo.cellCore.numID).includes(tile.numID)
          if (isCellCore) {
            setCellType(tile.numID, -1)
            let myColor = playerCore.myColor
            let cellCore = playerCore.gameInfo.cellCore
            setBallColorByNumID(cellCore.numID, '#ffffff')
            setBorderColorByNumID(cellCore.numID, playerCore.myColor)
          } else if (tile.upgradeLevel > 0) {
            setCellType(tile.numID, 5)
          } else {
            setCellType(tile.numID, 0)
          }

          setCellLevel(tile.numID, tile.upgradeLevel || 0)
        }))

        // // cell cores
        // this.players.forEach((player) => {
        //   let myColor = player.myColor
        //   let cellCore = player.gameInfo.cellCore
        //   setBallColorByNumID(cellCore.numID, '#ffffff')
        //   setBorderColorByNumID(cellCore.numID, myColor)
        //   setCellType(cellCore.numID, -1)
        // })
      }

      let shouldBeClickEvent = false
      let isTouch = false
      let tt = 0
      let toucher = this.UI.$refs['mounter']
      toucher.addEventListener('click', () => {
        if (isTouch) {
          return
        }
        onClick()
      }, false)
      toucher.addEventListener('mousemove', () => {
        clearTimeout(tt)
        shouldBeClickEvent = false
      })
      toucher.addEventListener('touchstart', () => {
        isTouch = true
        shouldBeClickEvent = true
        setTimeout(() => {
          shouldBeClickEvent = false
        }, 300)
      })
      toucher.addEventListener('touchmove', (evt) => {
        console.log(evt)
      })
      toucher.addEventListener('touchend', () => {
        if (!shouldBeClickEvent) {
          return
        }
        shouldBeClickEvent = false
        onClick()
      }, false)

      let info = FSCalc({ zPos: 0, camera: this.UI.camera })
      uniforms.screen.value.x = info.width
      uniforms.screen.value.y = info.height

      raycaster.params.Points.threshold = PARTICLE_SIZE * 0.5

      this.UI.execStack.syncStyle = () => {
        if (this.hasLeft) {
          return
        }
        if (!this.activeTiles) {
          return
        }
        raycaster.setFromCamera(mouse, this.UI.camera)
        let intersects = raycaster.intersectObject(this.pointcloud)
        this.intersects = intersects

        // console.log(this.activeTiles)

        if (intersects.length > 0) {
          let idx = intersects[0].index
          let brick = this.root.bricks[idx]
          if (brick) {
            this.hover = { numID: brick.numID, 'xid': brick.xid, 'yid': brick.yid, brick }
          }

          toucher.style.cursor = `pointer`
        } else {
          this.hover = false
          toucher.style.cursor = 'auto'
        }

        // onClick()
        userDataToStyles()

        uniforms.time.value = window.performance.now() * 0.001
        material.needsUpdate = true
      }
      this.pointcloud = new THREE.Points(geometry, material)
      this.$parent.$emit('add', this.pointcloud)
    }
  }
}
</script>

<style scoped>
.colored-layer{
  background-color: rgba(0, 0, 0, 0.5);
}
.scroller{
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
.posabs{
  position: absolute;
  top: 0px;
  left: 0px;
}
.full{
  width: 100%;
  height: 100%;
}
.centerise{
  display: flex;
  justify-content: center;
  align-items: center;
}

.gen-cells-title{
  font-size: 30px;
  color: white;
}

.overlay.leaderboard{

  width: 389px;
  position: absolute;
  top: 12px;
  right: 12px;
}
.overlay.gameover{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: calc(100% - 2px);
  padding-top: 1px;
  padding-bottom: 1px;
  overflow: scroll;
  color: white;
  background-color: rgba(0, 0, 0, 0.589);
}

.gv-title{
  font-size: 30px;
  font-weight: bolder;
}
.gv-restart{
  background: white;
  appearance: none;
  border: none;
  outline: none;
  background-color: white;
  margin: 20px;
  margin-left: 0px;
  font-weight: normal;
  padding: 20px;
  border-radius: 30px;
  font-size: 28px;
  cursor: pointer;
}
.gv-box{
  width: calc(80% - 40px);
  margin: 30px auto;
  background-color: rgba(255, 255, 255, 0.589);
  padding: 20px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
